import { ReactNode } from 'react';
import { Image } from 'react-native';

import { ConversationProvider } from '@oui/app-core/src/components/ConversationContext';
import { useTheme } from '@oui/app-core/src/styles';

export function WidgetProviders({ children }: { children?: ReactNode }) {
  // @ts-expect-error
  const { theme } = useTheme();
  return (
    <ConversationProvider
      botName="Rae"
      showTabsAfterCompletion
      botAvatar={
        <Image source={require('../../assets/Avatar.png')} style={{ width: 40, height: 40 }} />
      }
    >
      {children}
    </ConversationProvider>
  );
}
